import { Component } from '@angular/core';

import { MessageService as PrimeMessageService } from 'primeng/api';

import { Alert } from '../../../models/alert.model';
import { MessageService } from '../../../services/message.service';
import { AlertType } from '../../../enumerators/messages.enum';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  alerts: Array<Alert> = [];

  timer: any;
  descripcionBase: string = "";
  finTimer: any;

  constructor(private messageService: MessageService, private primeMessageService: PrimeMessageService) {
  }

  ngOnInit() {
    this.messageService.startAlert().subscribe((alert: Alert) => {
      this.primeMessageService.clear();
        this.setAlertData(alert);
        this.primeMessageService.add({ severity: alert.class, summary: '', detail: alert.description, life: alert.timer});
    });
  }

  setAlertData(alert: Alert) {
    switch (alert.type) {
      case AlertType.Success:
        alert.class = "success"
        break;

      case AlertType.Warning:
        alert.class = "warn"
        break;

      case AlertType.Error:
        alert.class = "error"
        break;

      case AlertType.Information:
        alert.class = "info"
        break;

      default:
        break;
    }
  }

}
